<template>
  <router-link :to="to" :class="bClass" :title="text">
    <template v-if="icon">
      <icon :name="icon" :size="size"></icon>
    </template>
    <template v-if="text">
      {{ text }}
    </template>
  </router-link>
</template>
<script>
import IncludeHelperComponent from '../plugins/includeHelperComponent'

export default {
  extends: IncludeHelperComponent,
  name: 'v-weirdo-router',
  props: {
    tag: {
      type: String,
      default: () => {
        return 'button'
      },
    },
    icon: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: 'fa-1x',
    },
    to: {
      type: String|Object,
      default: () => {
        return 'home.principal'
      },
    },
    text: {
      type: String,
      default: null,
    },
    bClass: {
      type: String,
    },
  },
}
</script>
